import React, { useEffect, useState } from 'react';
import { hrAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Info } from 'lucide-react';

export default function SkillLevelsPage() {
  const [levels, setLevels] = useState([]);
  useEffect(() => { hrAPI.skillLevels().then(r => setLevels(r.data || [])).catch(() => {}); }, []);
  const colors = {
    S1: 'bg-slate-100 text-slate-700 border-slate-300',
    S2: 'bg-blue-50 text-blue-700 border-blue-300',
    S3: 'bg-amber-50 text-amber-700 border-amber-300',
    S4: 'bg-emerald-50 text-emerald-700 border-emerald-300',
  };
  return (
    <div className="space-y-5" data-testid="hr-skill-levels-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] flex items-center gap-2"><Info className="w-6 h-6 text-pink-600" /> Skill Levels</h1>
        <p className="text-sm text-slate-500 mt-0.5">Fixed 4-tier competency scheme for hard skills</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {levels.map(l => (
          <Card key={l.code} className={`border ${colors[l.code] || 'border-slate-200'} shadow-none`} data-testid={`hr-level-${l.code}`}>
            <CardContent className="p-4 flex items-start gap-3">
              <div className={`w-10 h-10 rounded-lg border flex items-center justify-center font-bold ${colors[l.code]}`}>{l.code}</div>
              <div><p className="text-sm font-medium text-[#0F172A]">{l.code}</p><p className="text-sm text-slate-600">{l.description}</p></div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
